import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheHeartOfOurMission() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="the-heart-of-our-mission" className="dark bg-background text-foreground relative flex min-h-[70vh] w-full items-center justify-center overflow-hidden py-24">
      {}
      <div className="absolute inset-0 z-0">
        <video autoPlay loop muted playsInline className="h-full w-full object-cover opacity-10 blur-xl grayscale">
          <source src="/videos/movement_art_bg.mp4" type="video/mp4" />
          {}
          <div className="bg-background h-full w-full" />
        </video>
        {}
        <div className="bg-background/40 absolute inset-0 mix-blend-overlay" />
      </div>

      {}
      <div ref={ref} className={`relative z-10 container mx-auto px-6 text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="mx-auto max-w-4xl">
          <blockquote className="font-serif text-primary text-3xl font-medium italic leading-tight tracking-wide md:text-5xl lg:text-6xl">
            &ldquo;To help children discover hope, healing, and agency through
            gentle, creative expression.&rdquo;
          </blockquote>

          <div className="mt-12 flex justify-center">
            <Button asChild variant="ghost" className="text-foreground hover:text-primary hover:bg-primary/10 border-primary/20 h-12 rounded-full border px-8 text-lg transition-all duration-300">
              <Link to="#">
                Learn More
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}